// extracted by mini-css-extract-plugin
export default {"buttons_vertical":"ForgottenPassword_buttons_vertical__Uj-ov"};